<template>
  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link text-white" data-widget="pushmenu" href="#">
          <i class="fas fa-bars"></i>
        </a>
      </li>
      <template v-if="$screen.sm">
        <li class="nav-item">
          <router-link
            :to="{ name: 'home', params: { locale } }"
            class="nav-link text-white"
          >
            {{ $t("inicio") }}</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'contacto', params: { locale } }"
            class="nav-link text-white"
          >
            {{ $t("contacto") }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'ubicacion', params: { locale } }"
            class="nav-link text-white"
          >
            {{ $t("ubicacion") }}
          </router-link>
        </li>
      </template>
      <li v-if="!$screen.sm" class="nav-item">
        <LocaleChanger />
      </li>
    </ul>

    <!-- Right navbar links -->

    <ul class="navbar-nav ml-auto">
      <li v-if="$screen.sm" class="nav-item">
        <LocaleChanger />
      </li>
      <!-- <li class="nav-item">
        <a
          class="nav-link"
          data-widget="control-sidebar"
          data-slide="true"
          href="#"
        >
         
          <span style="color: Dodgerblue;">
            <i class="fab fa-twitter"></i>
          </span>
        </a>
      </li> -->
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
import LocaleChanger from "./LocaleChanger";

export default {
  components: {
    LocaleChanger,
  },
};
</script>

<style></style>

<i18n>
{
  "es": {
    "inicio" : "Inicio",
    "contacto": "Contacto",
    "ubicacion" : "Ubicación"      
  },
  "en": {
    "inicio" : "Home",
    "contacto": "Contact",
    "ubicacion" : "Location"
  }
}
</i18n>
